export default __webpack_public_path__ + "static/media/Warmup Track Athletics2.a80d41e0.jpg";